import React from 'react';
import Icon from 'components/AppIcon';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium nav-transition ${
            selectedCategory === category.id
              ? 'bg-primary text-white shadow-medium'
              : 'bg-surface text-text-secondary border border-border hover:text-primary hover:border-primary'
          }`}
        >
          <Icon name={category.icon} size={16} />
          <span>{category.label}</span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;